// extracted by mini-css-extract-plugin
export default {"customRow":"Opportunities_customRow__xkBwd","bgcolor":"Opportunities_bgcolor__9R+sx"};